import React, { useState, useEffect } from "react";
import {
  Container,
  Box,
  Typography,
  Paper,
  Button,
  Tab,
  Tabs,
  Grid,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { IconButton } from "@mui/material";
import { ChevronLeftOutlined, Menu } from "@mui/icons-material";
import Navigation from "../../../components/Navigation";
import HolidayRequestForm from "../../../components/Holidays/HolidayRequestForm";
import OvertimeForm from "../../../components/Holidays/OvertimeForm";
import SnackbarAlert from "../../../components/SnackbarAlert";
import ConfirmModal from "../../../components/ConfirmModal";
import routes from "../../../routes";
import MenuComponent from "../../../components/MenuComponent";
import dayjs from "dayjs";
import {
  addToLocalStorage,
  updateInLocalStorage,
} from "../../../services/localStorage";
import {
  holidayRequestFields,
  overTimeRequestFields,
} from "../../../services/helper";
const CreateHoliday = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [fileNames, setFileNames] = useState([]);
  const [fileObjects, setFileObjects] = useState([]);
  const [fromInsight, setFromInsight] = useState(false);
  const [overtimeEntries, setOvertimeEntries] = useState([]);
  const [totalWorkingDays, setTotalWorkingDays] = useState(0);
  const [highlightedField, setHighlightedField] = useState(null);
  const [isDraft, setIsDraft] = useState(false);
  const [nextActionModal, setNextActionModal] = useState(false);
  const [overtimeFormData, setOvertimeFormData] = useState({
    projectType: "",
    subProjectType: "",
    leaveType: "",
    instructedBy: "",
    position: "",
    variationOrderNo: "",
    dateOfObservation: "",
    overtimeEntries: [],
    attachedFile: [],
    additionalNotes: "",
    managerNotes: "",
  });
  const [holidayFormData, setHolidayFormData] = useState({
    leaveType: "",
    dateRange: [null, null],
    attachedFile: [],
    additionalNotes: "",
    managerNotes: "",
  });

  const [tabIndex, setTabIndex] = useState(0);
  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
  });
  const [confirmModal, setConfirmModal] = useState(false);
  // const [isQuery, setIsQuery] = useState(false);
  useEffect(() => {
    if (state?.holidayData) {
      if (state.status === "holiday") {
        const initialDateRange = [
          state.holidayData.dateRange[0]
            ? dayjs(state.holidayData.dateRange[0].$d)
            : null,
          state.holidayData.dateRange[1]
            ? dayjs(state.holidayData.dateRange[1].$d)
            : null,
        ];
        setHolidayFormData({
          leaveType: state.holidayData.leaveType,
          dateRange: initialDateRange,
          attachedFile: state.holidayData.attachedFile,
          additionalNotes: state.holidayData.additionalNotes,
          managerNotes: state.holidayData.managerNotes,
        });
        setFileNames(state.holidayData.attachedFile);
        setFileObjects(state.holidayData.attachedFile);
      } else {
        const initialOverTimeEntries = state.holidayData.overtimeEntries
          ? state.holidayData.overtimeEntries.map((entry) => {
              // Convert dateRange to dayjs objects
              if (!entry.repeatDate) {
                const dateRange = entry.dateRange.map((data) =>
                  data ? dayjs(data.$d) : null,
                );

                return {
                  dateRange,
                  duration: entry.duration, // Set workingDays as a decimal value
                };
              } else {
                return {
                  repeatDate: entry.repeatDate,
                };
              }
            })
          : [];

        setOvertimeFormData({
          projectType: state.holidayData.projectType,
          subProjectType: state.holidayData.subProjectType,
          leaveType: state.holidayData.leaveType,
          instructedBy: state.holidayData.instructedBy,
          position: state.holidayData.position,
          variationOrderNo: state.holidayData.variationOrderNo,
          dateOfObservation: state.holidayData.dateOfObservation,
          overtimeEntries: initialOverTimeEntries,
          attachedFile: state.holidayData.attachedFile,
          additionalNotes: state.holidayData.additionalNotes,
          managerNotes: state.holidayData.managerNotes,
        });
        setFileNames(state.holidayData.attachedFile);
        setOvertimeEntries(initialOverTimeEntries);
      }
      if (state.highlighted) setHighlightedField(state.highlighted);
      setFromInsight(state.fromInsight);
    }
  }, [state]);

  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  useEffect(() => {
    if (state && state.status) {
      setTabIndex(state.status === "holiday" ? 0 : 1);
    }
  }, [state]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  const handleChange = (e) => {
    const { name } = e.target;
    let value;
    if (tabIndex === 0) {
      if (name === "attachedFile") {
        value = e.target?.files[0].name;
        setHolidayFormData({
          ...holidayFormData,
          [name]: [...(holidayFormData[name] || []), value],
        });
      } else if (name === "removeFile") {
        value = e.target.value;
        setHolidayFormData((prev) => ({
          ...prev,
          attachedFile: prev.attachedFile.filter(
            (fileName) => fileName !== value,
          ),
        }));
      } else {
        value = e.target.value;
        setHolidayFormData({ ...holidayFormData, [name]: value });
      }
    } else {
      if (name === "attachedFile") {
        value = e.target?.files[0].name;
        setOvertimeFormData({
          ...overtimeFormData,
          [name]: [...(overtimeFormData[name] || []), value],
        });
      } else if (name === "removeFile") {
        value = e.target.value;
        setOvertimeFormData((prev) => ({
          ...prev,
          attachedFile: prev.attachedFile.filter(
            (fileName) => fileName !== value,
          ),
        }));
      } else if (name === "addOvertime") {
        value = e.target.value;
        let overtimeName = "overtimeEntries";
        setOvertimeFormData({
          ...overtimeFormData,
          overtimeEntries: overtimeFormData[overtimeName] ? value : [],
        });
      } else if (name === "removeOvertime") {
        let index = e.target.value;
        setOvertimeFormData((prev) => ({
          ...prev,
          overtimeEntries: prev.overtimeEntries.filter((_, i) => i !== index),
        }));
      } else {
        value = e.target.value;
        setOvertimeFormData({ ...overtimeFormData, [name]: value });
      }
    }
  };

  const handleDraftClick = () => {
    setIsDraft(true); // Set to true if it's a draft
    setConfirmModal(true); // Open the modal
  };

  const handleSubmitClick = () => {
    setIsDraft(false); // Set to false if it's a final submit
    setConfirmModal(true); // Open the modal
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setConfirmModal(false);
    console.log("Holiday request submitted:", holidayFormData);
    const id = `id-${Math.random().toString(36).substr(2, 9)}-${Date.now()}`;
    if (tabIndex === 0) {
      addToLocalStorage("holiday", {
        id: id,
        leaveType: holidayFormData.leaveType,
        attachedFile: holidayFormData.attachedFile,
        dateRange: holidayFormData.dateRange,
        additionalNotes: holidayFormData.additionalNotes,
        managerNotes: holidayFormData.managerNotes,
        status: "Pending",
        type: "holiday",
        isDraft: false,
      });
      setSnackbar({
        open: true,
        severity: "success",
        message: "A new holiday Request is created!",
      });
    } else {
      addToLocalStorage("overtime", {
        id: id,
        projectType: overtimeFormData.projectType,
        subProjectType: overtimeFormData.subProjectType,
        leaveType: overtimeFormData.leaveType,
        instructedBy: overtimeFormData.instructedBy,
        position: overtimeFormData.position,
        variationOrderNo: overtimeFormData.variationOrderNo,
        overtimeEntries: overtimeFormData.overtimeEntries,
        attachedFile: overtimeFormData.attachedFile,
        dateOfObservation: overtimeFormData.dateOfObservation,
        additionalNotes: overtimeFormData.additionalNotes,
        managerNotes: holidayFormData.managerNotes,
        type: "overtime",
        status: "Pending",
        isDraft: false,
      });
      setSnackbar({
        open: true,
        severity: "success",
        message: "A new Overtime Request is created!",
      });
    }
    handleClear();
    setNextActionModal(true);
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    setConfirmModal(false);
    console.log("Holiday Request Update Data:", holidayFormData);
    if (tabIndex === 0) {
      updateInLocalStorage("overtime", state.holidayData.id, {
        ...overtimeFormData,
        id: state.holidayData.id,
        isDraft: false,
      });
      setSnackbar({
        open: true,
        severity: "success",
        message: "A new holiday Request is updated!",
      });
    } else {
      updateInLocalStorage("holiday", state.holidayData.id, {
        ...overtimeFormData,
        id: state.holidayData.id,
        isDraft: false,
      });
      setSnackbar({
        open: true,
        severity: "success",
        message: "A new Overtime Request is updated!",
      });
    }
    handleClear();
  };

  const handleApprove = (e) => {
    e.preventDefault();
    setConfirmModal(false);
    console.log("Holiday Request Approved Data:", holidayFormData);
    if (tabIndex === 0) {
      updateInLocalStorage("holiday", state.holidayData.id, {
        ...holidayFormData,
        id: state.holidayData.id,
        isDraft: false,
        status: "Approved",
      });
      setSnackbar({
        open: true,
        severity: "success",
        message: "A holiday Request is Approved!",
      });
    } else {
      updateInLocalStorage("overtime", state.holidayData.id, {
        ...overtimeFormData,
        id: state.holidayData.id,
        isDraft: false,
        status: "Approved",
      });
      setSnackbar({
        open: true,
        severity: "success",
        message: "A Overtime Request is Approved!",
      });
    }
  };
  const handleQuery = (e) => {
    e.preventDefault();
    // setConfirmModal(false);
    // if (tabIndex === 0) {
    //   updateInLocalStorage("holiday", state.holidayData.id, {
    //     ...holidayFormData,
    //     id: state.holidayData.id,
    //     isDraft: false,
    //     status: "Queried",
    //     type: "holiday",
    //   });
    //   setSnackbar({
    //     open: true,
    //     severity: "success",
    //     message: "A holiday Request is Queried!",
    //   });
    // } else {
    //   updateInLocalStorage("overtime", state.holidayData.id, {
    //     ...overtimeFormData,
    //     id: state.holidayData.id,
    //     isDraft: false,
    //     status: "Queried",
    //     type: "overtime",
    //   });
    //   setSnackbar({
    //     open: true,
    //     severity: "success",
    //     message: "A Overtime Request is Queried!",
    //   });
    // }
    // setIsQuery(true);
  };
  const handleReject = (e) => {
    e.preventDefault();
    setConfirmModal(false);
    console.log("Holiday Request Rejected Data:", holidayFormData);
    if (tabIndex === 0) {
      updateInLocalStorage("holiday", state.holidayData.id, {
        ...holidayFormData,
        id: state.holidayData.id,
        isDraft: false,
        status: "Rejected",
      });
      setSnackbar({
        open: true,
        severity: "success",
        message: "A holiday Request is Rejected!",
      });
    } else {
      updateInLocalStorage("overtime", state.holidayData.id, {
        ...overtimeFormData,
        id: state.holidayData.id,
        isDraft: false,
        status: "Rejected",
      });
      setSnackbar({
        open: true,
        severity: "success",
        message: "A Overtime Request is Rejected!",
      });
    }
  };

  const handleEdit = (field, value) => {
    console.log("Editing field value:", field, value);

    if (field === "attachedFile") {
      value = value.name;
    }

    setHighlightedField(field); // Highlight the field being edited
    setOvertimeFormData((prevData) => ({ ...prevData, [field]: value }));
  };

  const handleDraft = () => {
    const id =
      state.holidayData?.id ||
      `id-${Math.random().toString(36).substr(2, 9)}-${Date.now()}`;
    setConfirmModal(false);
    if (tabIndex === 0) {
      // Handle Holiday Draft
      if (state.holidayData === undefined) {
        addToLocalStorage("holiday", {
          id: id,
          leaveType: holidayFormData.leaveType,
          attachedFile: holidayFormData.attachedFile,
          dateRange: holidayFormData.dateRange,
          additionalNotes: holidayFormData.additionalNotes,
          status: "Pending",
          type: "holiday",
          isDraft: true,
        });
        setSnackbar({
          open: true,
          severity: "success",
          message: "A new holiday request is saved as draft!",
        });
      } else {
        updateInLocalStorage("holiday", state.holidayData.id, {
          ...holidayFormData,
          id: state.holidayData.id,
          isDraft: true,
        });
        setSnackbar({
          open: true,
          severity: "success",
          message: "Holiday request is updated as draft!",
        });
      }
    } else {
      // Handle Overtime Draft
      if (state.holidayData === undefined) {
        addToLocalStorage("overtime", {
          id: id,
          projectType: overtimeFormData.projectType,
          subProjectType: overtimeFormData.subProjectType,
          leaveType: overtimeFormData.leaveType,
          instructedBy: overtimeFormData.instructedBy,
          position: overtimeFormData.position,
          variationOrderNo: overtimeFormData.variationOrderNo,
          overtimeEntries: overtimeFormData.overtimeEntries,
          dateOfObservation: overtimeFormData.dateOfObservation,
          attachedFile: overtimeFormData.attachedFile,
          dateRange: overtimeFormData.dateRange,
          additionalNotes: overtimeFormData.additionalNotes,
          status: "Pending",
          type: "overtime",
          isDraft: true,
        });
        setSnackbar({
          open: true,
          severity: "success",
          message: "A new overtime request is saved as draft!",
        });
      } else {
        updateInLocalStorage("overtime", state.holidayData.id, {
          ...overtimeFormData,
          id: state.holidayData.id,
          isDraft: true,
        });
        setSnackbar({
          open: true,
          severity: "success",
          message: "Overtime request is updated as draft!",
        });
      }
    }
    handleClear();
    setNextActionModal(true);
  };

  const handleCancel = () => {};

  const handleClear = () => {
    setFileNames([]);
    if (tabIndex === 0) {
      setHolidayFormData({
        leaveType: "",
        attachedFile: "",
        additionalNotes: "",
        dateRange: [null, null],
      });
    } else {
      setTotalWorkingDays(0);
      setOvertimeEntries([]);
      setOvertimeFormData({
        projectType: "",
        subProjectType: "",
        leaveType: "",
        instructedBy: "",
        position: "",
        variationOrderNo: "",
        dateRange: [null, null],
        overtimeEntries: [],
        attachedFile: null,
        additionalNotes: "",
      });
    }
  };
  return (
    <Container
      maxWidth="xs"
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#ecf0f7",
      }}
    >
      <Dialog open={nextActionModal} onClose={() => setNextActionModal(false)}>
        <DialogTitle>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Next Steps
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Do you want to create a new request or return to the main menu?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => {
              setNextActionModal(false);
              setConfirmModal(false); // Ensure the confirm modal is closed
              handleClear(); // Reset form for a new request
            }}
          >
            Create New Request
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setNextActionModal(false);
              navigate("/my-holidays"); // Navigate to the main menu
            }}
          >
            Return to Main Menu
          </Button>
        </DialogActions>
      </Dialog>
      <Box
        sx={{
          height: "129px",
          backgroundColor: "#1C1468",
          color: "white",
          display: "flex",
          alignItems: "center",
          marginLeft: "-24px",
          marginRight: "-24px",
          zIndex: 3,
          justifyContent: "space-between",
          position: "fixed",
          width: isNonMobile ? "444px" : "calc(100vw + 10px)",
        }}
      >
        <IconButton
          edge="start"
          sx={{ marginLeft: "10px" }}
          color="inherit"
          onClick={() => navigate(routes.myHolidays.path)}
        >
          <ChevronLeftOutlined />
        </IconButton>
        <Typography sx={{ fontSize: "16px" }} variant="h5" fontWeight="bold">
          {tabIndex === 0
            ? "Create Holiday Request"
            : "Create Overtime Request"}
        </Typography>
        <IconButton
          edge="end"
          color="inherit"
          sx={{ marginRight: "15px" }}
          onClick={handleDrawerToggle}
        >
          <Menu />
        </IconButton>
        <MenuComponent
          open={drawerOpen} // Drawer visibility
          onClose={handleDrawerToggle} // Handler to close the drawer
        />
      </Box>

      <Paper
        sx={{ backgroundColor: "#fff", padding: 3, margin: "159px 0 90px" }}
      >
        <Tabs
          value={tabIndex}
          onChange={(event, newValue) => {
            setTabIndex(newValue);
          }}
          sx={{ marginBottom: "30px" }}
        >
          <Tab label="Holiday" />
          <Tab label="Overtime" />
        </Tabs>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmitClick(); // Trigger submit behavior when the form is submitted
          }}
        >
          <Typography
            variant="h6"
            fontWeight="bold"
            sx={{ marginBottom: "30px" }}
          >
            {tabIndex === 0 ? "Holiday Request Details" : "Overtime Details"}
          </Typography>
          {tabIndex === 0 ? (
            <HolidayRequestForm
              formData={holidayFormData}
              handleChange={handleChange}
              fileNames={fileNames}
              fileObjects={fileObjects}
              highlightedField={highlightedField}
              setFileNames={setFileNames}
              setFileObjects={setFileObjects}
            />
          ) : (
            <OvertimeForm
              formData={overtimeFormData}
              handleChange={handleChange}
              fileNames={fileNames}
              fileObjects={fileObjects}
              setFileNames={setFileNames}
              setFileObjects={setFileObjects}
              highlightedField={highlightedField}
              overtimeEntries={overtimeEntries}
              setOvertimeEntries={setOvertimeEntries}
              totalWorkingDays={totalWorkingDays}
              setTotalWorkingDays={setTotalWorkingDays}
            />
          )}

          {fromInsight && (
            <Grid
              container
              spacing={2}
              sx={{ marginTop: "20px", justifyContent: "center" }}
            >
              {/* Approve and Reject buttons on the same row */}
              <Grid item>
                <Button
                  variant="contained"
                  color="success"
                  sx={{ marginRight: "10px" }} // Margin to the right for spacing
                  onClick={handleApprove}
                >
                  Approve
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ marginRight: "10px" }} // Margin to the right for spacing
                  onClick={handleQuery}
                >
                  Query
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleReject}
                >
                  Reject
                </Button>
              </Grid>
            </Grid>
          )}
          <Grid
            container
            spacing={2}
            sx={{ marginTop: "20px", justifyContent: "space-between" }}
          >
            {/* Submit and Save Draft buttons on the same row */}
            <Grid item>
              <Button
                variant="contained"
                color="success"
                sx={{ marginRight: "10px" }}
                onClick={handleSubmitClick} // Trigger submit on click
              >
                Submit
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={handleDraftClick} // Trigger draft save on click
              >
                Save Draft
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>

      <Navigation />
      <SnackbarAlert
        open={snackbar.open}
        onClose={handleClose}
        severity={snackbar.severity}
        message={snackbar.message}
      />
      <ConfirmModal
        open={confirmModal}
        onClose={(field, value) => {
          setConfirmModal(false);
          if (field || value) {
            handleEdit(field, value);
          } else {
            handleCancel();
          }
        }}
        title={
          tabIndex === 0
            ? "Holiday Request Summary"
            : "Overtime Request Summary"
        }
        fields={tabIndex === 0 ? holidayRequestFields : overTimeRequestFields}
        formData={tabIndex === 0 ? holidayFormData : overtimeFormData}
        handleEdit={handleEdit}
        handleConfirm={
          isDraft
            ? handleDraft
            : state?.holidayData
              ? handleUpdate
              : handleSubmit
        }
        fileObjects={fileObjects}
        handleDraft={handleDraft}
        isDraft={isDraft}
      />
    </Container>
  );
};

export default CreateHoliday;
